import { LANGUAGE_LEVEL_LABELS, SENIORITY_LABELS, type Match, type Requirement } from '../catalog.ts';
import { MatchBadge } from './MatchBadge.tsx';

interface Props {
  requirements?: Requirement[];
  coversCount?: number | null;
  teamMode?: 'ALONE' | 'TEAM' | null;
  match?: Match | null;
  // `extra` : l'extra regarde la mission et voit sa compatibilité ; `resto` : l'établissement relit ce qu'il a demandé.
  perspective: 'extra' | 'resto';
}

const levelOf = (r: Requirement) =>
  r.minLevel ? ` · ${(r.kind === 'ROLE' ? SENIORITY_LABELS : LANGUAGE_LEVEL_LABELS)[r.minLevel]?.toLowerCase()} minimum` : '';

export function RequirementsList({ requirements = [], coversCount, teamMode, match, perspective }: Props) {
  if (requirements.length === 0 && !coversCount && !teamMode) return null;
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ fontWeight: 800 }}>Profil recherché</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {coversCount ? <span className="badge badge-neutral">{coversCount} couverts</span> : null}
        {teamMode && <span className="badge badge-neutral">{teamMode === 'ALONE' ? 'Seul(e) sur le poste' : 'En équipe'}</span>}
        {requirements.map((r) => (
          <span key={r.itemId} className={`badge ${r.importance === 'REQUIRED' ? 'badge-pending' : 'badge-neutral'}`} title={r.importance === 'REQUIRED' ? 'Obligatoire' : 'Souhaité'}>
            {r.label}{levelOf(r)}{r.importance === 'REQUIRED' ? ' ·  obligatoire' : ''}
          </span>
        ))}
      </div>
      {perspective === 'extra' && <MatchBadge match={match} perspective="extra" />}
    </div>
  );
}
